import type { TRssDirectoryCatalogStoredEntry, TRssDirectoryEntry } from '../models/rssDirectory'
import rssDirectorySeedJson from '../data/rss-directory-seed.json'
import { rssDirectoryCatalogStoredEntrySchema } from '../models/rssDirectory'
import {
  getRssDirectoryEntryFromCatalog,
  isEnabledRssDirectoryEntryId,
  isRssDirectoryEntryInCatalog,
  listEnabledMaterializedEntries,
  listEnabledStoredEntries,
  materializeRssDirectoryCatalog,
  materializeRssDirectoryEntry,
  rssDirectoryListingSummary
} from './rssDirectoryCatalogResolve'
import { resolveRssDirectoryEntryLocale } from './rssDirectoryLocale'

export { rssDirectoryListingSummary } from './rssDirectoryCatalogResolve'

export {
  resolveRssLayoutForTemplate,
  RSS_STORY_FULL_LAYOUT
} from './rssDirectoryLayouts'

/** Seed catalog when D1 row is absent (also used in tests). Source: `data/rss-directory-seed.json`. */
export const RSS_DIRECTORY_SEED_STORED: readonly TRssDirectoryCatalogStoredEntry[]
  = rssDirectorySeedJson.map((entry) => {
    const locale = resolveRssDirectoryEntryLocale(entry as { language?: string, country?: string })
    return rssDirectoryCatalogStoredEntrySchema.parse({ ...entry, ...locale })
  })

/** Materialized seed entries (enabled only). */
export const RSS_DIRECTORY_ENTRIES = listEnabledMaterializedEntries(RSS_DIRECTORY_SEED_STORED)

export type RssDirectoryEntryId = TRssDirectoryCatalogStoredEntry['id']

const seedEnabledIds = new Set(RSS_DIRECTORY_ENTRIES.map(e => e.id))

const seedEntryById = new Map<string, TRssDirectoryEntry>(
  RSS_DIRECTORY_ENTRIES.map(entry => [entry.id, entry])
)

/** @deprecated Runtime catalog comes from feeds API / D1; seed fallback for tests and offline helpers. */
export function getRssDirectoryEntry(id: string): TRssDirectoryEntry | undefined {
  return seedEntryById.get(id)
}

/** @deprecated Prefer enabled catalog from feeds API. */
export function isRssDirectoryEntryId(id: string): boolean {
  return seedEnabledIds.has(id)
}

export {
  getRssDirectoryEntryFromCatalog,
  isEnabledRssDirectoryEntryId,
  isRssDirectoryEntryInCatalog,
  listEnabledMaterializedEntries,
  listEnabledStoredEntries,
  materializeRssDirectoryCatalog,
  materializeRssDirectoryEntry
}
